import React, { useCallback } from 'react';

import { useAnalytics } from 'util/analytics';
import { SanitizeMode, useSanitizedHtmlProps } from 'util/sanitized';

import styles from './styles.module.scss';

interface INewsItem {
  topic: string,
  href: string,
  imgSrc?: string,
  description: string,
}

const NewsItem = ({
  topic,
  href,
  description,
  imgSrc = '/assets/resort/base-related-news.jpg',
}: INewsItem) => {
  const a = useAnalytics();
  const onClickNews = useCallback(() => {
    // console.log('PRE NewsItem gtm event VIEW CONTENT');
    a.viewContent({ content: 'Related News', 'Landing Page': href });
  }, [description, topic]);

  const { dangerouslySetInnerHTML: { __html: sanitizedDescription } } = useSanitizedHtmlProps(description || topic || '', SanitizeMode.TextOnly);

  return (
    <div className={styles.container}>
      <img
        className={styles.img}
        alt={sanitizedDescription}
        src={imgSrc}
      />
      <a
        href={href}
        className={styles.link}
        onClick={onClickNews}
      >
        <span dangerouslySetInnerHTML={{ __html: topic }} />
      </a>
    </div>
  );
};

export default NewsItem;
